import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../modules/auth';
import UserMenu from '../../../components/common/header/UserMenu'

const UserMenuContainer = ({ compact = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector(({ auth }) => ({
        user: auth.user,
    }));

    const onLogout = () => {
        navigate('/login');
        dispatch(logout());
    };

    return (
        <UserMenu user={user} onLogout={onLogout} compact={compact} />
    )
}

export default UserMenuContainer
